module.exports = __webpack_public_path__ + "img/Star-Active.97766fcd.svg";